import * as CONST from "../const/action.const";
import { removeObjectWithId } from "../helpers/utils";

const initialState = {
  teachers_list: [],
  new_teacher: null,
  info_teacher: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.CREATE_TEACHER_ACCOUNT_SUCCESS:
      return {
        ...state,
        new_teacher: payload,
        teachers_list: state.teachers_list.concat(payload),
      };
    case CONST.CREATE_TEACHER_ACCOUNT_FAILURE:
      return {
        ...state,
        new_teacher: null,
      };
    case CONST.GET_TEACHERS_LIST_SUCCESS:
      return {
        ...state,
        teachers_list: payload.reverse(),
      };
    case CONST.GET_TEACHERS_LIST_FAILURE:
      return {
        ...state,
        teachers_list: [],
      };
    case CONST.FIND_TEACHER_INFO_SUCCESS:
      return {
        ...state,
        info_teacher: payload,
      };
    case CONST.FIND_TEACHER_INFO_FAILURE:
      return {
        ...state,
        info_teacher: null,
      };
    case CONST.UPDATE_TEACHER_INFO_SUCCESS:
      return {
        ...state,
        info_teacher: payload,
      };
    case CONST.UPDATE_TEACHER_INFO_FAILURE:
      return {
        ...state,
        info_teacher: payload
      };
    case CONST.DELETE_TEACHER_SUCCESS:
      const new_teachers_list=removeObjectWithId(state.teachers_list,payload)
      return {
        ...state,
        teachers_list: new_teachers_list
      };
    case CONST.DELETE_TEACHER_FAILURE:
      return {
        ...state,
        teachers_list: state.teachers_list
      };
    default:
      return state;
  }
}
